module.exports = __webpack_public_path__ + "assets/img/default_avatar.16c9a3bd.png";